import { Labels, validateTaxId } from "../../../../../features/data-types"
import { FieldType, FieldValue, option } from "../../../../../features/ui"
import { toDate } from "../../../../../utils/typeUtils"
import { Check, CheckType } from "../../../state/types"

export const CheckFields = (
    defaultValues?: Partial<Check>,
    values?: Partial<Check>,
    maxAmount?: number,
    onChange?: (fieldName: string) => (value?: FieldValue) => void
) => [
    {
        name: 'type',
        type: FieldType.SELECT,
        label: 'Tipo',
        options: Object.values(CheckType).map(type => option(type, Labels.checkTypeLabel(type))),
        defaultValue: defaultValues?.type,
        value: values?.type,
        onChange: onChange && onChange('type')
    },
    {
        name: 'name',
        type: FieldType.TEXT,
        label: 'Nombre / Razón Social',
        defaultValue: defaultValues?.name,
        value: values?.name,
        onChange: onChange && onChange('name')
    },
    {
        name: 'amount',
        type: FieldType.PRICE,
        label: 'Monto',
        defaultValue: defaultValues?.amount,
        value: values?.amount,
        max: maxAmount,
        onChange: onChange && onChange('amount')
    },
    {
        name: 'issueDate',
        type: FieldType.DATE,
        label: 'Fecha de Emisión',
        defaultValue: toDate(defaultValues?.issueDate),
        value: toDate(values?.issueDate),
        onChange: onChange && onChange('issueDate')
    },
    {
        name: 'paymentDate',
        type: FieldType.DATE,
        label: 'Fecha de Pago',
        defaultValue: toDate(defaultValues?.paymentDate),
        value: toDate(values?.paymentDate),
        onChange: onChange && onChange('paymentDate')
    },
    {
        name: 'taxId',
        type: FieldType.NUMBER,
        label: 'CUIT / CUIL',
        defaultValue: defaultValues?.taxId,
        value: values?.taxId,
        validate: validateTaxId,
        onChange: onChange && onChange('taxId')
    },
    {
        name: 'endorsable',
        type: FieldType.BOOLEAN,
        label: 'A la Orden',
        defaultValue: defaultValues?.endorsable,
        value: values?.endorsable,
        onChange: onChange && onChange('endorsable')
    }
]
